export enum RuleObjectTypes {
  REGULAMIN = 'Regulamin',
}
